import { translations } from "../translations";
import SectionHeading from "./SectionHeading";

export default function GetStarted() {
  const t = translations;

  return (
    <SectionHeading greenText={t.getStartedTitle}>
      {t.getStartedText}
    </SectionHeading>
  );
}
